import { render } from "./EquipoFormEC.vue?vue&type=template&id=5f3db45c"
import script from "./EquipoFormEC.vue?vue&type=script&lang=js"
export * from "./EquipoFormEC.vue?vue&type=script&lang=js"

import "./EquipoFormEC.vue?vue&type=style&index=0&id=5f3db45c&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__